import { render, staticRenderFns } from "./WriteDataLog.vue?vue&type=template&id=24f3926e"
import script from "./WriteDataLog.vue?vue&type=script&lang=js"
export * from "./WriteDataLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports